export default __webpack_public_path__ + "media/transfer-bubble/icon-people-118932b5.png";